import {useTranslation} from "react-i18next";
import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {hasCapability, InstallationsContext} from "./App";
import HeaderSection from "./HeaderSection";
import PermanentAlertsBar from "./PermanentAlertsBar";
import {INSTALLATION_ALERT_STATUS_DISCONNECTED} from "../api/wimhome-api";
import StaticBanner from "./StaticBanner";
import {extractFileName, timestampToDate} from "../utilities";
import Alerts from "./Alerts";
import ResourceLink from "./ResourceLink";
import MainArea from "./MainArea";
import ActiveParamsTile from "./ActiveTile";
import FooterSection from "./FooterSection";

export default function ParamsPage({ history, currRoute }) {
  const {t, i18n} = useTranslation();
  const {
    selectedInst,
    installations,
    loadInstParameters,
  } = useContext(InstallationsContext);

  let mainContentRef = React.createRef();

  const [paramsModal, setParamsModal] = useState(null);
  const [installationParameters, setInstallationParameters] = useState(new Map());

  const paramsLoaded = useRef(0);

  const selectedInstallationData = (selectedInst && installations) ? installations[selectedInst] : null;

  const loadParameters = useCallback(() =>
  {
    paramsLoaded.current = 1; //loading
    return loadInstParameters(selectedInst)
        .then((retrievedParams) => {
          if(retrievedParams == null) {
            alert("Cannot load installation parameters");
            paramsLoaded.current = 3; //error
          } else {
            setInstallationParameters(retrievedParams);
            paramsLoaded.current = 2; //loaded
          }
        })
        .catch((error) => {
          console.log(error);
          alert(error.message);
        })
  }, []);

  useEffect(() => {
    if(selectedInst == null) {
      return;
    }
    if(paramsLoaded.current === 0)
      loadParameters();
  }, [loadParameters, selectedInst]);

  return (
      <>
        <HeaderSection
            currRoute={currRoute}
            mainContentRef={mainContentRef}
        />
        <section className="main-content" ref={mainContentRef}>
          <PermanentAlertsBar />
          {selectedInstallationData && (
              <>
                {(selectedInstallationData.status === INSTALLATION_ALERT_STATUS_DISCONNECTED) && (
                    <StaticBanner
                        backgroundColor="#d9534f"
                        color="white"
                        icon='exclamation-triangle'
                        message={`${t('statusPage.disconnectionAlertBanner')} ${timestampToDate(selectedInstallationData.lastStatusUpdate).toLocaleString(i18n.language)}`}
                    />
                )}
                {(hasCapability(selectedInstallationData, 'alerts-show')) && (
                    <Alerts
                        alerts={selectedInstallationData.alerts}
                        canManageAlerts={hasCapability(selectedInstallationData, 'alerts-management')}
                        installationStatus={selectedInstallationData.status}
                    />
                )}
                <MainArea title={`${t("paramsPage.title")}`}>
                  {selectedInstallationData && (
                      <>
                        {[...installationParameters.values()].map( (deviceData) => {
                          return <ActiveParamsTile
                              key={deviceData.id}
                              descType={""}
                              details={null}
                              iconName={extractFileName(deviceData.iconURL)}
                              onClickHandler={null}
                              tileId={deviceData.id}
                              tileState={"active-state"}
                              title={deviceData.name}
                          />
                        })
                        }
                      </>
                  )}
                  {!selectedInstallationData && (
                      <p>{`${t("paramsPage.loadingMessage")}`}</p>
                  )}
                </MainArea>
              </>
          )}
          <FooterSection/>
        </section>
      </>
  )
}